import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import ReferralView from "@components/views/Profile/Referral";

function Referral() {
  return <ReferralView />;
}

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      ...(await getMessagesForNamespaces(locale, ["common", "accounts", "referrals"])),
    },
  };
}

export default Referral;
